import React from 'react';
import { MapPin, ExternalLink, Navigation } from 'lucide-react';

const Venue = ({ venue }) => {
  // Venue coordinates
  const lat = venue?.lat ?? 50.855544;
  const lng = venue?.lng ?? 4.342502;
  
  return (
    <section id="lieu" className="px-6 py-24 bg-gradient-to-b to-black from-gray-950 md:py-32">
      <div className="mx-auto max-w-5xl">
        <div className="grid gap-12 items-center md:grid-cols-2">
          <div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-500 mb-4 block">
              Le lieu
            </span>
            <h2 className="mb-6 text-4xl font-black tracking-tight md:text-5xl">
              {venue.name.toUpperCase()}
            </h2>
            <div className="mb-8 space-y-2 text-lg text-gray-300">
              <p>{venue.address}</p>
              <p>{venue.city}</p>
              <p>{venue.country}</p>
            </div>
            <a
              href={venue.mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex gap-2 items-center px-6 py-3 text-white border transition-colors border-white/30 hover:bg-white hover:text-black group"
            >
              <Navigation size={18} />
              <span className="text-sm font-semibold tracking-wider uppercase">Itinéraire</span>
              <ExternalLink size={14} className="opacity-50 group-hover:opacity-100" />
            </a>
          </div>

          <div className="relative">
            {/* Real OpenStreetMap */}
            <div className="overflow-hidden relative bg-gray-900 rounded-lg aspect-square">
              <iframe
                title="Le Phare du Kanaal Map"
                width="100%"
                height="100%"
                src="https://www.openstreetmap.org/export/embed.html?bbox=4.339283108711244%2C50.85402138740305%2C4.34636414051056%2C50.85707595396346&amp;layer=mapnik&marker=50.855518622674545%2C4.342761432062744"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ filter: 'grayscale(100%) invert(92%) contrast(90%)' }}
                className="absolute inset-0"
              />
              {/* Overlay label */}
              <div className="absolute right-4 bottom-4 left-4 z-10 p-3 rounded bg-black/80">
                <div className="flex gap-2 items-center">
                  <MapPin size={16} className="text-white" />
                  <span className="text-sm font-semibold">{venue.name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Venue;
